// // import { useState } from "react";
// // import YouCan from '../images/logo-youcan.png';
// // import { useLanguage } from "../context/LanguageProvider";

// // export default function AnnonceYoucan() {
// //   const { t } = useLanguage();
// //   const [visible, setVisible] = useState(true);

// //   if (!visible) return null;

// //   return (
// //     <div
// //       dir="rtl"
// //       className="mx-auto px-4 pt-3"
// //     >
// //       {/* Import Cairo font */}
// //       <style>{`@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap');`}</style>

// //       <div
// //         className="relative overflow-hidden rounded-2xl max-lg:block flex items-center justify-between gap-5 px-8 py-6 max-lg:px-3 max-lg:py-3 min-h-[128px]"
// //         style={{ background: "#1a0a10", border: "1px solid #3a1020" }}
// //       >
// //         <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#581a35] opacity-50 blur-3xl"></div>

// //         {/* Geometric decorative circles */}
// //         <span
// //           className="pointer-events-none absolute rounded-full"
// //           style={{
// //             top: -30, right: -30,
// //             width: 180, height: 180,
// //             border: "1px solid rgba(210, 106, 129, 0.18)",
// //           }}
// //         />
// //         <span
// //           className="pointer-events-none absolute rounded-full"
// //           style={{
// //             top: -60, right: -60,
// //             width: 270, height: 270,
// //             border: "1px solid rgba(215, 153, 167, 0.1)",
// //           }}
// //         />
// //         <span
// //           className="pointer-events-none absolute rounded-full"
// //           style={{
// //             bottom: -50, left: "30%",
// //             width: 200, height: 200,
// //             border: "1px solid rgba(161, 115, 124, 0.08)",
// //           }}
// //         />

// //         {/* Close button */}
// //         <button
// //           onClick={() => setVisible(false)}
// //           className="absolute top-3 left-3 z-10 w-7 h-7 max-lg:h-5 max-lg:w-5 rounded-full flex items-center justify-center text-white/60 text-sm transition-colors"
// //           style={{
// //             background: "rgba(255,255,255,0.08)",
// //             border: "1px solid rgba(255,255,255,0.12)",
// //           }}
// //           onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.18)")}
// //           onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
// //         >
// //           ✕
// //         </button>

// //         {/* Left: text content */}
// //         <div className="flex-1 z-10">
// //           {/* Badge */}
// //           <div className="flex justify-between items-center">
// //             <div>
// //               <img 
// //                   src={YouCan} 
// //                   alt="youcan" 
// //                   className="w-20 h-20 max-lg:w-12 max-lg:h-12 object-contain" 
// //                 />
// //               <div
// //                 className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[10px] font-semibold mb-2"
// //                 style={{
// //                   background: "rgba(220,40,75,0.18)",
// //                   border: "1px solid rgba(220,40,75,0.35)",
// //                   color: "#ff8aaa",
// //                 }}
// //               >
// //                 <span
// //                   className="w-1.5 h-1.5 rounded-full"
// //                   style={{
// //                     background: "#e8325a",
// //                     boxShadow: "0 0 0 3px rgba(232,50,90,0.25)",
// //                   }}
// //                 />
// //                 {t('youcan.new_badge')}
// //               </div>

// //             </div>
// //             <div className="mt-8">
// //               <a
// //                 href="/integration/applications"
// //                 className="rounded-xl px-4 py-1 lg:hidden max-lg:px-2 max-lg:py-1 max-lg:text-[11px] text-white font-bold border hover:bg-[#b01f3e] border-[#b01f3e] text-sm transition-all active:scale-95"
// //                 style={{
// //                   fontFamily: "'Cairo', sans-serif",
// //                   letterSpacing: "0.3px",
// //                 }}
// //               >
// //                 {t('youcan.cta')}
// //               </a>
// //             </div>
// //           </div>

// //           {/* Title */}
// //           <h3
// //             className="text-xl max-lg:text-sm font-extrabold text-white mb-1.5 leading-snug"
// //             style={{ fontFamily: "'Cairo', sans-serif" }}
// //           >
// //             {t('youcan.title_prefix')}{" "}
// //              <span style={{ color: "#e8325a" }}>{t('youcan.title_highlight')}</span>{" "}
// //             {t('youcan.title_suffix')}
// //           </h3>

// //           {/* Description */}
// //           <p
// //             className="text-xs max-lg:text-[10px] leading-7 max-lg:leading-5"
// //             style={{ color: "rgba(255,255,255,0.7)", maxWidth: 500 }}
// //           >
// //            {t('youcan.description')}
// //           </p>
// //         </div>

// //         {/* Right: stats + CTA */}
// //         <div className="flex flex-col items-end max-lg:grid max-lg:g gap-16 z-10 shrink-0">
// //           {/* Stats row */}
// //           <div className="flex max-lg:gap-1.5 max-lg:mt-3 gap-2.5">
// //             {/* Delivered stat */}
// //             <div
// //               className="relative rounded-xl max-lg:px-2 max-lg:py-1 px-4 py-2.5 text-center"
// //               style={{
// //                 background: "rgba(255,255,255,0.06)",
// //                 border: "1px solid rgba(255,255,255,0.10)",
// //                 minWidth: 88,
// //               }}
// //             >
// //               <span
// //                 className="absolute top-2 right-2.5 w-1.5 h-1.5 rounded-full"
// //                 style={{ background: "#e8325a" }}
// //               />
// //               <span className="block text-2xl max-lg:text-sm font-extrabold text-white leading-tight">
// //                 4,500 +
// //               </span>
// //               <div className="flex items-center gap-2 justify-center">
// //                 <span className="block text-[11px] max-lg:text-[10px] mt-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>
// //                   {t('youcan.synced_orders')}
// //                 </span>
// //                 <span className="block text-xs max-lg:text-[10px] font-bold mt-0.5" style={{ color: "#4ade80" }}>
// //                   ↑ 100%
// //                 </span>
// //               </div>
// //             </div>

// //             {/* Price */}
// //             <div
// //               className="rounded-xl px-3.5 py-2.5  max-lg:px-2 max-lg:py-1 text-center"
// //               style={{
// //                 background: "rgba(220,40,75,0.15)",
// //                 border: "1px solid rgba(220,40,75,0.30)",
// //               }}
// //             >
// //               <span className="block text-lg max-lg:text-sm font-extrabold text-white leading-tight">
// //                +97%
// //               </span>
// //               <span className="block text-[11px] mt-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>
// //               {t('youcan.error_reduction')}
// //               </span>
// //             </div>

// //             {/* Returned stat */}
// //             <div
// //               className="rounded-xl px-3.5 py-2.5  max-lg:px-2 max-lg:py-1 text-center"
// //               style={{
// //                 background: "rgba(255,255,255,0.06)",
// //                 border: "1px solid rgba(255,255,255,0.10)",
// //                 minWidth: 70,
// //               }}
// //             >
// //               <div className="gap-2 justify-center">
// //                 <span className="block text-[11px]  max-lg:text-[10px] mt-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>
// //                 {t('youcan.continuous_sync')}
// //                 </span>
// //                 <span className="block text-lg max-lg:text-sm font-extrabold text-white">24/7</span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* CTA Button */}
// //           <a
// //             href="/integration/applications"
// //             className="rounded-xl px-4 py-2 max-lg:hidden max-lg:px-3 max-lg:py-2 max-lg:text-xs text-white font-bold border hover:bg-[#b01f3e] border-[#b01f3e] text-sm transition-all active:scale-95"
// //             style={{
// //               fontFamily: "'Cairo', sans-serif",
// //               letterSpacing: "0.3px",
// //             }}
// //           >
// //             {t('youcan.cta')}
// //           </a>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// import { useState } from "react";
// import Shopify from '../images/Shopify.png';

// export default function AnnonceShopify() {
//   const [visible, setVisible] = useState(true);

//   if (!visible) return null;

//   return (
//     <div dir="rtl" className="mx-auto px-4 pt-3">
//       {/* Import Cairo font */}
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap');`}</style>

//       <div
//         className="relative overflow-hidden rounded-2xl flex items-center justify-between gap-6 px-8 py-5 max-lg:flex-col max-lg:items-stretch max-lg:px-4 max-lg:py-3"
//         style={{
//           background: "linear-gradient(135deg, #165128 0%, #0c2519 55%, #0f1d13 100%)",
//           border: "1px solid #1f3a26",
//           fontFamily: "'Cairo', sans-serif",
//         }}
//       >
//         {/* Ambient glow */}
//         <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-[#95BF47] opacity-[0.12] blur-3xl pointer-events-none" />
//         <div className="absolute -bottom-16 left-10 w-64 h-64 rounded-full bg-[#5E8E3E] opacity-[0.10] blur-3xl pointer-events-none" />

//         {/* Signature element: oversized outline shopping-bag watermark */}
//         <svg
//           className="pointer-events-none absolute -left-6 -bottom-10 opacity-[0.06] max-lg:hidden"
//           width="220" height="220" viewBox="0 0 24 24" fill="none"
//           stroke="#95BF47" strokeWidth="1"
//         >
//           <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
//           <path d="M3 6h18" />
//           <path d="M16 10a4 4 0 0 1-8 0" />
//         </svg>

//         {/* Diagonal accent rule */}
//         <span
//           className="pointer-events-none absolute top-0 bottom-0"
//           style={{
//             right: "38%",
//             width: 1,
//             background: "linear-gradient(180deg, transparent, rgba(149,191,71,0.25), transparent)",
//           }}
//         />

//         {/* Close button */}
//         <button
//           onClick={() => setVisible(false)}
//           className="absolute top-3 left-3 z-10 w-7 h-7 max-lg:h-6 max-lg:w-6 rounded-full flex items-center justify-center text-white/60 text-sm transition-colors"
//           style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)" }}
//           onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.16)")}
//           onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.06)")}
//         >
//           ✕
//         </button>

//         {/* Left: brand + text */}
//         <div className="relative z-10 flex-1">
//           <div className="flex justify-between items-center mb-0 max-lg:mb-0">
//             <div className="flex items-center gap-2 mb-1">
//               <div
//                 className="flex items-center justify-center rounded-xl shrink-0"
//               >
//                 <img src={Shopify} alt="shopify" className="w-24 h-24 object-contain" />
//               </div>
//               <div
//                 className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold"
//                 style={{ background: "rgba(149,191,71,0.14)", border: "1px solid rgba(149,191,71,0.35)", color: "#b8e08a" }}
//               >
//                 <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#95BF47", boxShadow: "0 0 0 3px rgba(149,191,71,0.25)" }} />
//                 تكامل جديد
//               </div>
//             </div>
//             <div className="flex justify-end lg:hidden">
//               <a
//                 href="/integration/applications"
//                 className="inline-flex mt-5 max-w-max rounded-xl px-5 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-xs text-[#0d1710] font-extrabold text-sm transition-all active:scale-95"
//                 style={{ background: "#95BF47" }}
//                 onMouseEnter={(e) => (e.currentTarget.style.background = "#a9d15b")}
//                 onMouseLeave={(e) => (e.currentTarget.style.background = "#95BF47")}
//               >
//                 ابدأ الربط الآن
//               </a>
//             </div>

//           </div>

//           <h3 className="text-2xl max-lg:text-lg font-extrabold text-white mb-2 leading-snug">
//             اربط متجرك على <span style={{ color: "#95BF47" }}>Shopify</span> بمنصتك في دقائق
//           </h3>

//           <p className="text-sm max-lg:text-xs leading-8 max-lg:leading-6" style={{ color: "rgba(255,255,255,0.62)", maxWidth: 480 }}>
//             مزامنة تلقائية للطلبات والمخزون على مدار الساعة، بدون تدخل يدوي وبدون أخطاء إدخال. كل تغيير في متجرك ينعكس فورًا.
//           </p>
//         </div>

//         {/* Right: stats */}
//         <div >
//           <div>
//             <div className="relative z-10 flex flex-row max-lg:flex-row gap-3 max-lg:gap-2 max-lg:mt-0 shrink-0">
//               <div
//                 className="rounded-xl px-4 py-3 max-lg:px-3 max-lg:py-2 text-center min-w-[92px]"
//                 style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
//               >
//                 <span className="block text-2xl max-lg:text-base font-extrabold text-white leading-tight">24/7</span>
//                 <span className="block text-[11px] max-lg:text-[10px] mt-1" style={{ color: "rgba(255,255,255,0.5)" }}>
//                   مزامنة مستمرة
//                 </span>
//               </div>

//               <div
//                 className="rounded-xl px-4 py-3 max-lg:px-3 max-lg:py-2 text-center min-w-[92px]"
//                 style={{ background: "rgba(149,191,71,0.12)", border: "1px solid rgba(149,191,71,0.30)" }}
//               >
//                 <span className="block text-2xl max-lg:text-base font-extrabold leading-tight" style={{ color: "#b8e08a" }}>%97+</span>
//                 <span className="block text-[11px] max-lg:text-[10px] mt-1" style={{ color: "rgba(255,255,255,0.5)" }}>
//                   تقليل الأخطاء
//                 </span>
//               </div>

//               <div
//                 className="rounded-xl px-4 py-3 max-lg:px-3 max-lg:py-2 text-center min-w-[92px]"
//                 style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
//               >
//                 <span className="block text-2xl max-lg:text-base font-extrabold text-white leading-tight">+4,500</span>
//                 <span className="block text-[11px] max-lg:text-[10px] mt-1" style={{ color: "rgba(255,255,255,0.5)" }}>
//                   طلب متزامن
//                 </span>
//               </div>
//             </div>
//             <div className="flex justify-end max-lg:hidden">
//               <a
//                 href="/integration/applications"
//                 className="inline-flex mt-5 max-w-max rounded-xl px-5 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-xs text-[#0d1710] font-extrabold text-sm transition-all active:scale-95"
//                 style={{ background: "#95BF47" }}
//                 onMouseEnter={(e) => (e.currentTarget.style.background = "#a9d15b")}
//                 onMouseLeave={(e) => (e.currentTarget.style.background = "#95BF47")}
//               >
//                 ابدأ الربط الآن
//               </a>
//             </div>


//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useState, useEffect, useRef } from "react";
import Shopify from '../images/Shopify.png';
import YouCan from '../images/logo-youcan.png';

// ---- Per-platform config -------------------------------------------------
// Add a new platform here and it plugs into the same banner automatically.
const PLATFORMS = [
  {
    key: "shopify",
    logo: Shopify,
    accent: "#95BF47",
    accentSoft: "rgba(149,191,71,0.14)",
    accentBorder: "rgba(149,191,71,0.35)",
    accentText: "#b8e08a",
    gradient: "linear-gradient(135deg, #165128 0%, #0c2519 55%, #0f1d13 100%)",
    border: "#1f3a26",
    glowTop: "#95BF47",
    glowBottom: "#5E8E3E",
    badge: "تكامل جديد",
    titlePrefix: "اربط متجرك على",
    titleHighlight: "Shopify",
    titleSuffix: "بمنصة NextLead في دقائق",
    description:
      "مزامنة تلقائية للطلبات والمخزون على مدار الساعة، بدون تدخل يدوي وبدون أخطاء إدخال. كل تغيير في متجرك ينعكس فورًا على NextLead.",
    cta: "ابدأ الربط الآن",
    ctaText: "#0d1710",
    stats: [
      { value: "24/7", label: "مزامنة مستمرة" },
      { value: "%100+", label: "تقليل الأخطاء", accent: true },
      { value: "2,000+", label: "طلب متزامن" },
    ],
  },
  {
    key: "youcan",
    logo: YouCan,
    accent: "#e8325a",
    accentSoft: "rgba(220,40,75,0.14)",
    accentBorder: "rgba(220,40,75,0.35)",
    accentText: "#ff8aaa",
    gradient: "linear-gradient(135deg, #4a0d1e 0%, #24040f 55%, #180208 100%)",
    border: "#3a1020",
    glowTop: "#e8325a",
    glowBottom: "#8c1b38",
    badge: "تكامل جديد",
    titlePrefix: "اربط متجرك على",
    titleHighlight: "YouCan",
    titleSuffix: "بمنصة NextLead في دقائق",
    description:
      "مزامنة تلقائية للطلبات والمخزون على مدار الساعة، بدون تدخل يدوي وبدون أخطاء إدخال. كل تغيير في متجرك ينعكس فورًا على NextLead.",
    cta: "ابدأ الربط الآن",
    ctaText: "#1a0308",
    stats: [
      { value: "24/7", label: "مزامنة مستمرة" },
      { value: "%97+", label: "تقليل الأخطاء", accent: true },
      { value: "4,500+", label: "طلب متزامن" },
    ],
  },
];

export default function AnnonceIntegrations() {
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
  if (paused || PLATFORMS.length <= 1) return;

  let intervalId;

  const timeoutId = setTimeout(() => {
    setActive((i) => (i + 1) % PLATFORMS.length);

    intervalId = setInterval(() => {
      setActive((i) => (i + 1) % PLATFORMS.length);
    }, 3000);
  }, 500); // First move after 0.5s

  return () => {
    clearTimeout(timeoutId);
    if (intervalId) clearInterval(intervalId);
  };
}, [paused]);

  if (!visible) return null;

  const p = PLATFORMS[active];

  return (
    <div dir="rtl" className="mx-auto px-4 pt-3">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap');
        @keyframes slideInRTL {
          from { opacity: 0; transform: translateX(-24px); }
          to { opacity: 1; transform: translateX(0); }
        }
        .annonce-slide { animation: slideInRTL 0.5s ease; }
        @keyframes fillBar {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>

      <div
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        className="relative overflow-hidden rounded-2xl flex items-center justify-between gap-6 px-8 py-5 max-lg:flex-col max-lg:items-stretch max-lg:px-4 max-lg:py-3 transition-all duration-500"
        style={{
          background: p.gradient,
          border: `1px solid ${p.border}`,
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {/* Ambient glow */}
        <div
          className="absolute -top-10 -right-10 w-72 h-72 rounded-full opacity-[0.12] blur-3xl pointer-events-none transition-colors duration-500"
          style={{ background: p.glowTop }}
        />
        <div
          className="absolute -bottom-16 left-10 w-64 h-64 rounded-full opacity-[0.10] blur-3xl pointer-events-none transition-colors duration-500"
          style={{ background: p.glowBottom }}
        />

        {/* Signature watermark */}
        <svg
          className="pointer-events-none absolute -left-6 -bottom-10 opacity-[0.06] max-lg:hidden"
          width="220" height="220" viewBox="0 0 24 24" fill="none"
          stroke={p.accent} strokeWidth="1"
        >
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
          <path d="M3 6h18" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>

        {/* Diagonal accent rule */}
        <span
          className="pointer-events-none absolute top-0 bottom-0"
          style={{
            right: "38%",
            width: 1,
            background: `linear-gradient(180deg, transparent, ${p.accentBorder}, transparent)`,
          }}
        />

        {/* Close button */}
        <button
          onClick={() => setVisible(false)}
          className="absolute top-3 left-3 z-10 w-7 h-7 max-lg:h-6 max-lg:w-6 rounded-full flex items-center justify-center text-white/60 text-sm transition-colors"
          style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.16)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.06)")}
        >
          ✕
        </button>

        {/* Left: brand + text */}
        <div key={`text-${p.key}`} className="relative z-10 flex-1 annonce-slide">
          <div className="flex justify-between items-center mb-0 max-lg:mb-0">
            <div className="flex items-center gap-2 mb-1">
              <div className="flex items-center justify-center rounded-xl shrink-0">
                <img src={p.logo} alt={p.titleHighlight} className="w-24 h-24 object-contain" />
              </div>
              <div
                className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold"
                style={{ background: p.accentSoft, border: `1px solid ${p.accentBorder}`, color: p.accentText }}
              >
                <span
                  className="w-1.5 h-1.5 rounded-full"
                  style={{ background: p.accent, boxShadow: `0 0 0 3px ${p.accentSoft}` }}
                />
                {p.badge}
              </div>
            </div>

            <div className="flex justify-end lg:hidden">
              <a
                href="/integration/applications"
                className="inline-flex mt-5 max-w-max rounded-xl px-5 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-xs font-extrabold text-sm transition-all active:scale-95"
                style={{ background: p.accent, color: p.ctaText }}
              >
                {p.cta}
              </a>
            </div>
          </div>

          <h3 className="text-2xl max-lg:text-lg font-extrabold text-white mb-2 leading-snug">
            {p.titlePrefix} <span style={{ color: p.accent }}>{p.titleHighlight}</span> {p.titleSuffix}
          </h3>

          <p className="text-sm max-lg:text-xs leading-8 max-lg:leading-6" style={{ color: "rgba(255,255,255,0.62)", maxWidth: 480 }}>
            {p.description}
          </p>

          {/* Platform switcher dots (progress fills over 5s, click to jump) */}
          {PLATFORMS.length > 1 && (
            <div className="flex items-center gap-2 mt-3">
              {PLATFORMS.map((plat, i) => (
                <button
                  key={plat.key}
                  onClick={() => setActive(i)}
                  aria-label={plat.titleHighlight}
                  className="relative h-1.5 rounded-full overflow-hidden transition-all"
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    width: i === active ? 28 : 8,
                  }}
                >
                  {i === active && (
                    <span
                      className="absolute inset-y-0 left-0 rounded-full"
                      style={{
                        background: plat.accent,
                        animation: paused ? "none" : "fillBar 3s linear forwards",
                      }}
                    />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Right: stats + CTA */}
        <div key={`stats-${p.key}`} className="annonce-slide">
          <div>
            <div className="relative z-10 flex flex-row max-lg:flex-row gap-3 max-lg:gap-2 max-lg:mt-0 shrink-0">
              {p.stats.map((stat, i) => (
                <div
                  key={i}
                  className="rounded-xl px-4 py-3 max-lg:px-3 max-lg:py-2 text-center min-w-[92px]"
                  style={
                    stat.accent
                      ? { background: p.accentSoft, border: `1px solid ${p.accentBorder}` }
                      : { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }
                  }
                >
                  <span
                    className="block text-2xl max-lg:text-base font-extrabold leading-tight"
                    style={{ color: stat.accent ? p.accentText : "#fff" }}
                  >
                    {stat.value}
                  </span>
                  <span className="block text-[11px] max-lg:text-[10px] mt-1" style={{ color: "rgba(255,255,255,0.5)" }}>
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex justify-end max-lg:hidden">
              <a
                href="/integration/applications"
                className="inline-flex mt-5 max-w-max rounded-xl px-5 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-xs font-extrabold text-sm transition-all active:scale-95"
                style={{ background: p.accent, color: p.ctaText }}
              >
                {p.cta}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}





// import { useState } from "react";
// import Shopify from '../images/Shopify.png';
// import YouCan from '../images/logo-youcan.png';
// import NextLeadLogo from '../images/nextlead-logo-solo.png';

// // ---- Per-platform config -------------------------------------------------
// // Add a platform here and it plugs straight into a half of the banner.
// const PLATFORMS = [
//   {
//     key: "shopify",
//     logo: Shopify,
//     accent: "#95BF47",
//     accentSoft: "rgba(149,191,71,0.14)",
//     accentBorder: "rgba(149,191,71,0.35)",
//     accentText: "#b8e08a",
//     glow: "#95BF47",
//     badge: "تكامل جديد",
//     title: "Shopify",
//     description: "مزامنة تلقائية للطلبات والمخزون على مدار الساعة.",
//     cta: "ابدأ الربط",
//     ctaText: "#0d1710",
//     stats: [
//       { value: "+4,500", label: "طلب متزامن" },
//       { value: "24/7", label: "مزامنة" },
//     ],
//   },
//   {
//     key: "youcan",
//     logo: YouCan,
//     accent: "#e8325a",
//     accentSoft: "rgba(220,40,75,0.14)",
//     accentBorder: "rgba(220,40,75,0.35)",
//     accentText: "#ff8aaa",
//     glow: "#e8325a",
//     badge: "تكامل جديد",
//     title: "YouCan",
//     description: "مزامنة تلقائية للطلبات والمخزون على مدار الساعة.",
//     cta: "ابدأ الربط",
//     ctaText: "#1a0308",
//     stats: [
//       { value: "+4,500", label: "طلب متزامن" },
//       { value: "24/7", label: "مزامنة" },
//     ],
//   },
// ];

// function PlatformHalf({ platform: p }) {
//   return (
//     <div className="relative z-10 flex-1 flex flex-col items-center text-center gap-3 px-6 py-6 max-lg:px-3 max-lg:py-4">
//       <div className="flex items-center justify-center">
//         <img src={p.logo} alt={p.title} className="w-16 h-16 max-lg:w-12 max-lg:h-12 object-contain" />
//       </div>

//       <div
//         className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold"
//         style={{ background: p.accentSoft, border: `1px solid ${p.accentBorder}`, color: p.accentText }}
//       >
//         <span className="w-1.5 h-1.5 rounded-full" style={{ background: p.accent, boxShadow: `0 0 0 3px ${p.accentSoft}` }} />
//         {p.badge}
//       </div>

//       <h3 className="text-lg max-lg:text-base font-extrabold text-white leading-snug">
//         <span style={{ color: p.accent }}>{p.title}</span>
//       </h3>

//       <p className="text-xs max-lg:text-[11px] leading-6" style={{ color: "rgba(255,255,255,0.62)", maxWidth: 260 }}>
//         {p.description}
//       </p>

//       <div className="flex items-center gap-2 mt-1">
//         {p.stats.map((stat, i) => (
//           <div
//             key={i}
//             className="rounded-lg px-3 py-1.5 text-center min-w-[72px]"
//             style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
//           >
//             <span className="block text-sm font-extrabold text-white leading-tight">{stat.value}</span>
//             <span className="block text-[9px] mt-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>
//               {stat.label}
//             </span>
//           </div>
//         ))}
//       </div>

//       <a
//         href="/integration/applications"
//         className="inline-flex mt-2 rounded-xl px-5 py-2 text-xs font-extrabold transition-all active:scale-95"
//         style={{ background: p.accent, color: p.ctaText }}
//       >
//         {p.cta}
//       </a>
//     </div>
//   );
// }

// export default function AnnonceIntegrations() {
//   const [visible, setVisible] = useState(true);
//   if (!visible) return null;

//   const [left, right] = PLATFORMS;

//   return (
//     <div dir="rtl" className="mx-auto px-4 pt-3">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap');
//         @keyframes syncPulse {
//           0%   { transform: translateX(0);   opacity: 0; }
//           15%  { opacity: 1; }
//           85%  { opacity: 1; }
//           100% { transform: translateX(var(--travel)); opacity: 0; }
//         }
//         .sync-dot { animation: syncPulse 2.2s ease-in-out infinite; }
//       `}</style>

//       <div
//         className="relative overflow-hidden rounded-2xl flex items-stretch max-lg:flex-col"
//         style={{
//           background: "linear-gradient(135deg, #10151a 0%, #0b1013 55%, #0d1210 100%)",
//           border: "1px solid rgba(255,255,255,0.08)",
//           fontFamily: "'Cairo', sans-serif",
//         }}
//       >
//         {/* Ambient glows from each brand, meeting in the middle */}
//         <div
//           className="absolute top-1/2 -translate-y-1/2 right-0 w-72 h-72 rounded-full opacity-[0.10] blur-3xl pointer-events-none"
//           style={{ background: left.glow }}
//         />
//         <div
//           className="absolute top-1/2 -translate-y-1/2 left-0 w-72 h-72 rounded-full opacity-[0.10] blur-3xl pointer-events-none"
//           style={{ background: right.glow }}
//         />

//         {/* Close button */}
//         <button
//           onClick={() => setVisible(false)}
//           className="absolute top-3 left-3 z-20 w-7 h-7 rounded-full flex items-center justify-center text-white/60 text-sm transition-colors"
//           style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)" }}
//           onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.16)")}
//           onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.06)")}
//         >
//           ✕
//         </button>

//         {/* Left half */}
//         <PlatformHalf platform={left} />

//         {/* Center: NextLead logo connecting both */}
//         <div className="relative z-10 flex flex-col items-center justify-center gap-3 px-4 py-6 max-lg:py-2 shrink-0 max-lg:w-full">
//           {/* connecting line + traveling dot, toward left half */}
//           <span
//             className="hidden lg:block absolute top-1/2 -translate-y-1/2 h-px"
//             style={{ right: "100%", width: 60, background: `linear-gradient(90deg, transparent, ${left.accent}55)` }}
//           />
//           <span
//             className="hidden lg:block sync-dot absolute top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full"
//             style={{ right: "100%", marginRight: 4, background: left.accent, "--travel": "-56px" }}
//           />

//           <div
//             className="relative w-20 h-20 max-lg:w-16 max-lg:h-16 rounded-2xl flex items-center justify-center"
//             style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)" }}
//           >
//             <img src={NextLeadLogo} alt="NextLead" className="w-14 h-14 max-lg:w-11 max-lg:h-11 object-contain" />
//           </div>
//           <span className="text-white text-xs font-bold whitespace-nowrap">NextLead</span>

//           {/* connecting line + traveling dot, toward right half */}
//           <span
//             className="hidden lg:block absolute top-1/2 -translate-y-1/2 h-px"
//             style={{ left: "100%", width: 60, background: `linear-gradient(90deg, ${right.accent}55, transparent)` }}
//           />
//           <span
//             className="hidden lg:block sync-dot absolute top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full"
//             style={{ left: "100%", marginLeft: 4, background: right.accent, "--travel": "56px" }}
//           />
//         </div>

//         {/* Right half */}
//         <PlatformHalf platform={right} />
//       </div>
//     </div>
//   );
// }